import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

export default function PrivacyPage() {
  const sections = [
    {
      title: 'Who we are',
      paragraphs: [
        'Top 3 Football Tipsters ("we", "our", "us") is the data controller responsible for personal information collected through this website and through our subscription services. We are committed to protecting your privacy and processing your personal data lawfully, fairly and transparently. If you have any question about this Privacy Policy or wish to exercise any of your rights, contact us at premiumtipsters@tip1x2bet.com.'
      ]
    },
    {
      title: 'What personal data we collect',
      paragraphs: [
        'We collect only the personal data we genuinely need to operate the Service. The categories of data we process are:'
      ],
      bullets: [
        'Identity and contact data — your name, email address, and country when you contact us or subscribe.',
        'Transaction data — the plan you purchase (15 or 30 days), the payment method used (PayPal, Skrill, Neteller, bank card, or crypto), and the payment reference. We never store card numbers or wallet private keys.',
        'Usage data — pages viewed, buttons clicked, and features used, collected via first-party analytics to improve the Service.',
        'Technical data — IP address, browser type, operating system, device identifiers, and time-zone — used exclusively for security and fraud prevention.',
        'Communications data — the content of any message you send us via the contact form or by email.'
      ]
    },
    {
      title: 'How we use your data',
      bullets: [
        'To provide the Service: activate your subscription, deliver tips, and give you access to the archive and Telegram channels.',
        'To communicate with you: respond to enquiries, send subscription updates, and, where you have opted in, occasional news about the platform.',
        'To take payment and prevent fraud: confirm your transaction with the relevant payment provider and detect suspicious activity.',
        'To improve the Service: understand how visitors use the site so we can refine content and features.',
        'To comply with legal obligations: retain records required by applicable tax and consumer-protection laws.'
      ]
    },
    {
      title: 'Legal bases for processing',
      paragraphs: [
        'When you are located in the United Kingdom or the European Economic Area, we rely on the following lawful bases under the UK GDPR / EU GDPR:'
      ],
      bullets: [
        'Contract — to perform the subscription agreement you enter into with us.',
        'Legitimate interests — to keep the Service secure, prevent fraud, and improve our features. We only rely on this basis where our interests are not overridden by your rights.',
        'Consent — for optional marketing communications and for non-essential cookies. You can withdraw consent at any time.',
        'Legal obligation — to comply with laws that apply to us, including tax record-keeping.'
      ]
    },
    {
      title: 'Who we share your data with',
      paragraphs: [
        'We do not sell or rent your personal data. We only share it with the following categories of recipients and only to the extent necessary:'
      ],
      bullets: [
        'Payment providers — PayPal, Skrill, Neteller, licensed card acquirers and, for crypto payments, the relevant public blockchain (which is by design pseudonymous).',
        'Infrastructure providers — hosting, email delivery, analytics, and customer-support tools that process data on our behalf under strict contractual safeguards.',
        'Professional advisors — accountants, auditors, and lawyers where the disclosure is required for compliance or legitimate business reasons.',
        'Public authorities — where we are legally required to disclose data, for example in response to a valid court order.'
      ]
    },
    {
      title: 'International transfers',
      paragraphs: [
        'Some of our service providers are located outside the United Kingdom or the European Economic Area. Whenever data is transferred internationally we ensure appropriate safeguards are in place — typically the UK International Data Transfer Agreement or the European Commission Standard Contractual Clauses — so that your data continues to enjoy an equivalent level of protection.'
      ]
    },
    {
      title: 'How long we keep your data',
      paragraphs: [
        'We retain personal data for as long as necessary for the purpose it was collected. Subscription records are kept for the duration of your subscription and for six years afterwards to comply with tax and consumer-protection obligations. Marketing preferences are kept until you unsubscribe. Contact-form messages are kept for up to twenty-four months. When retention is no longer necessary, data is deleted or fully anonymised.'
      ]
    },
    {
      title: 'Your rights',
      paragraphs: [
        'Subject to applicable law, you have the right to:'
      ],
      bullets: [
        'Access the personal data we hold about you and receive a copy of it.',
        'Ask us to correct inaccurate or incomplete data.',
        'Ask us to erase your data ("right to be forgotten") where we no longer need it.',
        'Ask us to restrict or object to certain processing activities.',
        'Receive your data in a portable, machine-readable format.',
        'Withdraw consent at any time where processing is based on consent.',
        'Lodge a complaint with a supervisory authority — for the UK, the Information Commissioner’s Office (ico.org.uk).'
      ]
    },
    {
      title: 'Cookies',
      paragraphs: [
        'We use a small number of first-party cookies to keep the site working (for example, to remember your currency preference) and to measure how the Service is used. We do not use advertising cookies. You can control cookies through your browser settings; blocking essential cookies may affect the functionality of the Service.'
      ]
    },
    {
      title: 'Security',
      paragraphs: [
        'We implement industry-standard technical and organisational measures to protect your data, including HTTPS encryption in transit, encryption at rest for sensitive fields, restricted staff access on a need-to-know basis, and regular security reviews. No system is entirely secure, but we take our obligation to protect your data extremely seriously.'
      ]
    },
    {
      title: 'Children',
      paragraphs: [
        'The Service is intended for users aged 18 and over. We do not knowingly collect personal data from anyone under 18. If you become aware that a minor has provided us with personal data, please contact us so that we can delete it.'
      ]
    },
    {
      title: 'Changes to this policy',
      paragraphs: [
        'We may update this Privacy Policy from time to time to reflect changes in the Service or in applicable law. The "last updated" date at the top of the page will always show when the most recent revision came into force. Where a change is material we will notify active subscribers by email.'
      ]
    },
    {
      title: 'Contact',
      paragraphs: [
        'Any question relating to this Privacy Policy — or a request to exercise any of your rights — can be sent to premiumtipsters@tip1x2bet.com. We aim to reply within twelve hours and to resolve every request within one month.'
      ]
    }
  ];

  return (
    <LegalPageLayout
      title="Privacy Policy"
      updated="June 2026"
      intro="This policy explains what personal data Top 3 Football Tipsters collects, how we use it, and the rights you have over it. We keep it short, plain-language, and free of legal jargon wherever possible."
      sections={sections}
    />
  );
}
